// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"layouts_Breadcrumb__FwBuX","Sidebar":"layouts_Sidebar__5htGo","blocktable":"layouts_blocktable__119IQ","blockContent":"layouts_blockContent__ImZz8"};